export default __webpack_public_path__ + "static/media/iconWarning.61b7d573.svg";